/**
 * Central copy for content-sync failure notifications (AB#8988 / ERR-007).
 * Sentence case, past tense, no exclamation marks, matches the action that
 * failed (syncing reference data on app open).
 */
export const CONTENT_SYNC_ERROR_MESSAGE =
    'Content sync failed. Reference data may be out of date until the next sync.';
